import { useData } from "../../../store/DataProvider";
import Staff from "./Staff";
import PaymentType from "./PaymentType";
import CurrentSales from "./CurrentSales";
import SubmitRow from "./SubmitRow";
import Totals from "./Totals";

const Sales = () => {
    const {
        settings: { paymentTypes },
        staff,
        alertStaff,
        selectedStaff,
        alertPaymentType,
        paymentType,
        currentSales,
        todayTotals,
    } = useData();

    return (
        <div className="second-column">
            {/* Beside .sale-container rather than inside it. Side by side the
                two scroll together, as they did when these were the top of
                the sale list; stacked they separate, so the selectors can sit
                above the service grid and the sale list below it. */}
            <div className="sales-container">
                <div className="buttons-wrapper">
                    <Staff
                        staff={staff}
                        currentSales={currentSales}
                        alertStaff={alertStaff}
                        selectedStaff={selectedStaff}
                    />
                    <PaymentType
                        paymentTypes={paymentTypes}
                        alertPaymentType={alertPaymentType}
                        selectedPaymentType={paymentType}
                    />
                </div>

                <div className="sale-container">
                    <CurrentSales currentSales={currentSales} />
                    <SubmitRow />
                </div>
            </div>

            <div className="totals-container">
                <div className="total-container">
                    <Totals
                        todayTotals={todayTotals}
                        staff={staff}
                        selectedStaff={selectedStaff}
                    />
                </div>
            </div>
        </div>
    );
};

export default Sales;
